<template>
    <div class="modal fade custom-right-modal" id="quotationAddTaskModal" ref="quotationAddTaskModal">
        <div class="modal-dialog" style="max-width: 90% !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Add Task</h4>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <form method="post" id="addTask" name="addTask">
                        <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                            <ul>
                                <li>{{ errorMessage }}</li>
                            </ul>
                        </div>
                        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                            <ul>
                                <li v-for="(v, k) in commonErrors" :key="k">
                                    <p v-for="error in v" :key="error" class="text-sm">
                                        {{ error }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <input class="form-control" v-model="form.title" id="title" name="title" placeholder="Title"/>
                            </div>
                            <div class="form-group">
                                        <textarea class="form-control" name="description" id="description" v-model="form.description"
                                                  placeholder="Write a description"></textarea>
                            </div>

                            <div class="row">
                                <div class="col-md-8" v-if="quotationData.user_type == 1 || quotationData.role == 'Admin'">
                                    <div class="custom-slect-drop">
                                        <div
                                            class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select">
                                            <v-select label="text" :filterable="false" :multiple="false"
                                                      v-model="form.assign_to"
                                                      :options="users"
                                                      :reduce="user => user.id"
                                                      @search="onVendorSearch"
                                                      @selected="onVendorSelect"
                                                      @deselected ="onVendorDeSelect">
                                                <template slot="no-options">
                                                    type to search assign to..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-html="option.name">
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center" v-html="option.name">
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <select class="form-control" id="userPriority" name="userPriority" v-model="form.priority_id">
                                        <option value="">All</option>
                                        <option v-for="(item, index) in task_priority" :value="item.id">{{item.priority_name}}</option>
                                    </select>
                                </div>
                            </div>
                            <br/>
                            <div class="row">
                                <div class="col-md-8">
                                    <date-picker format="MM/DD/YYYY" v-model="form.due_date" valueType="format" placeholder="Due Date"></date-picker>
                                </div>
                            </div>
                            <br/>

                            <div class="add-attchmnt">
                                <div class="pull-left">Add Attachment :</div>
                                <div class="form-group files color">
                                    <vue-dropzone :options="dropzoneOptions"
                                                  :id="'item-dropzone-attach'"
                                                  v-on:vdropzone-complete="(response) => afterAllUploadComplete(response)"
                                                  v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                    </vue-dropzone>
                                </div>
                            </div>
                            <div class="col-md-8 add-pg" id="add_files_attached">
                                <template v-if="form.files_attached.length">
                                    <template v-for="(item, index) in form.files_attached">
                                        <template v-if="item.image_type=='1'">
                                            <div class="pdf-dwn-sec" :class="'num_'+index">
                                                <a class="lightbox" href="#attach'+name+'">
                                                    <img :src="'/task_files/'+item.name" style="width:40px;height:32px;"></a>
                                                {{item.name}}
                                                <a class="fa fa-trash-alt fa-pull-right" style="padding:7px;" onclick="deleteFiles(item.name,index)"></a>
                                                <a :href="'/task_files/'+item.name" class="fa fa-download fa-pull-right"> download></a>
                                                <small class="light-clr">{{item.size}}</small>
                                            </div>
                                            <div class="lightbox-target" id="attach'+name+'">
                                                <img :src="'/task_files/'+item.name"><a class="lightbox-close" href="#"></a>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="pdf-dwn-sec" :class="'num_'+index">
                                                <span class="far fa-file-pdf"></span>
                                               {{item.name}}
                                                <a class="fa fa-trash-alt fa-pull-right" onclick="deleteFiles(item.name,index)"></a>

                                                <small class="light-clr">{{item.size}}</small>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" v-on:click="save" class="btn btn-blue" id="save_task_btn">Save</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: "QuotationAddTaskModal",
    components: {
        VueTypeaheadBootstrap,
        vueDropzone: vue2Dropzone,
        DatePicker
    },
    props: ['quotation', 'quotationData'],
    created() {
        this.form.quote_id = this.quotation.id;
        //this.getPriority();
    },
    mounted() {
        $(this.$refs.quotationAddTaskModal).on('show.bs.modal', () => {
            this.getPriority();
        });
    },
    data() {
        return {
            task_priority: [],
            submitted: false,
            form: {
                quote_id: null,
                title: null,
                assign_to: null,
                due_date: null,
                priority_id: null,
                description: null,
                files_attached: []
            },
            users: [],
            userData: null,
            dropzoneOptions: {
                url: window.route('tasks.addAttachments'),
                // thumbnailWidth: 150,
                createImageThumbnails: false,
                maxFilesize: 2048, //mb
                maxFiles: 10,
                addRemoveLinks: false,
                chunking: false,
                acceptedFiles: 'image/*',
                disablePreviews: true,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        afterAllUploadComplete(response) {
            //console.log('response', response);
        },
        afterUploadComplete(file, response) {
            //console.log('response', response);
            if(response.success==true){
                this.form.files_attached.push({
                    name: response.name,
                    size: response.size,
                    src: response.src,
                    image_type: response.image_type,
                });
                this.setSuccessMessage(response.message);
            } else {
                this.setErrorMessage('File not uploaded successfully');
            }
        },
        deleteFiles(name, index){
            this.form.files_attached.splice(index, 1);
        },
        getPriority(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('tasks.getPriority');

            return axios.post(apiUrl, {}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.success) {
                        this.task_priority = data.task_priority;
                    } else {
                        self.setErrorMessage(data.message);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        save() {
            this.form.quote_id = this.quotation.id;

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('tasks.store');

            return axios.post(apiUrl, this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('taskAddedEvent', data.data);
                        $('#quotationAddTaskModal').modal('hide');
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

        onVendorSelect(event){
            console.log(event)
        },
        onVendorDeSelect(event){
            console.log(event)
        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendorNew(loading, search, this);
            }
        },
        searchVendorNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('tasks.search'), {search: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.users = data.data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        download(path, attach) {
            let url = '/quote_files/' + attach.file_name;

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url,  {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        // Service that handles ajax call
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", attach.file_name);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
